<template>
  <div class="campaign-form-container">
    <v-container>
      <v-layout row class="padding">
        <v-flex xs4 sm12 offset-sm3>
          <v-card
            class="mx-auto mt-4 pa-5 text-center text-no-wrap"
            max-width="1000"
            id="limited-products"
          >
          <div class="text-dash">
          <h1>Masters</h1>
          </div>
          <div class="dashboard">
            <router-link :to="{ name: 'AnnuityPlans', params: {}}" class="card-icon" title="Annuity Plans Master">
              <div class="card-icon-body">
                <h2>Annuity Plans</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'Banks', params: {}}" class="card-icon" title="Bank Master">
              <div class="card-icon-body">
                <h2>Bank</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'StockBrockers', params: {}}" class="card-icon" title="Stock Borkers Master">
              <div class="card-icon-body">
                <h2>Stock Brokers</h2>
              </div>
            </router-link>
            
            <router-link :to="{ name: 'ListingAIF', params: {}}" class="card-icon" title="Portfolio Manager-AIF">
              <div class="card-icon-body">
                <h2>Portfolio Manager - AIF/PMS</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'RealEstate', params: {}}" class="card-icon" title="Real Estate Masters">
              <div class="card-icon-body">
                <h2>Real Estate </h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'Insurance', params: {}}" class="card-icon" title="Insurance Master">
              <div class="card-icon-body">
                <h2>Insurance</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'PensionFund', params: {}}" class="card-icon" title="Pension Fund Master">
              <div class="card-icon-body">
                <h2>Pension Fund Manager</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'ListPostOfcDetails'}" class="card-icon" title="Post Office Master">
              <div class="card-icon-body">
                <h2>Post Office</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'Nbfc'}" class="card-icon" title="NBFC Master">
              <div class="card-icon-body">
                <h2>NBFC</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'Bullion'}" class="card-icon" title="Bullion Master">
              <div class="card-icon-body">
                <h2>Bullion</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'GroupInsurancePolicy'}" class="card-icon" title="Group Insurance Policy Master">
              <div class="card-icon-body">
                <h2>Group Insurance Policy</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'LifeInsurancePolicy'}" class="card-icon" title="Life Insurance Policy Master">
              <div class="card-icon-body">
                <h2>Life Insurance Policy</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'NonLifeInsurancePolicy'}" class="card-icon" title="Non Life Insurance Policy Master">
              <div class="card-icon-body">
                <h2>Non Life Insurance Policy</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'WillPrice'}" class="card-icon" title="Will Price Master">
              <div class="card-icon-body">
                <h2>Will Price</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'riskometerMaster'}" class="card-icon" title="Will Price Master">
              <div class="card-icon-body">
                <h2>RiskoMeter</h2>
              </div>
            </router-link>
            <router-link :to="{ name: 'protectometerMaster'}" class="card-icon" title="Will Price Master">
              <div class="card-icon-body">
                <h2>ProtectoMeter</h2>
              </div>
            </router-link>
          </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    allCampaign:'',
    allUsers:'',
    allTopic:'',
    allRegisterdUsers:'',
    paidUsers:'',
    freeUsers:'',
    unpaidUsers:''
  }),
  methods: {},
  mounted() {
     
  },
};
</script>